import * as angular from 'angular';
import fourOFourComponent from './four-o-four.component';
import fourOFourRoutes from './four-o-four.routes';

export default angular
  .module('FourOFour', [])
  .component('fourOFour', fourOFourComponent)
  .config((RouterServiceProvider) => {
    RouterServiceProvider.configureStates(fourOFourRoutes);
  })
  .name;



// WEBPACK FOOTER //
// ./src/app/four-o-four/four-o-four.module.js